import { api } from "./client";

// Типы 1:1 к pydantic-схемам backend/src/seller_helper/orders/schemas.py (снейк-кейс).

export type MpCode = "wb" | "ozon" | "ym";

export interface OrdersMeta {
  min_date: string | null;
  max_date: string | null;
  source_rows: number;
  source_qty: number;
  missing_1c_rows: number;
  missing_1c_qty: number;
}

export interface OrdersUnmapped {
  mp_code: string;
  rows: number;
  qty: number;
}

export interface OrdersMatrixRow {
  article: string;
  id_1c: string | null;
  mp_code: MpCode;
  code_1c: string | null;
  name: string | null;
  brand: string | null;
  /** Помесячные ряды, выровнены по months отчёта. */
  qty: number[];
  total: number[];
  cost: number[];
  margin: number[];
  costed_qty: number[];
  /** Дневные скаляры: окна от date_to, НЕ ограничены date_from (см. orders/matrix.py). */
  current_mtd: number;
  previous_mtd: number;
  last30: number;
  last90: number;
  first_sale: string | null;
  last_sale: string | null;
  spark: number[];
}

export interface OrdersStock {
  article: string;
  /** null — строка остатка 1С. */
  mp_code: MpCode | null;
  stock_mp: number;
  stock_1c: number;
}

export interface OrdersMatrixReport {
  date_from: string;
  date_to: string;
  as_of: string;
  generated_at: string;
  from_cache: boolean;
  months: string[];
  bucket_count: number;
  rows: OrdersMatrixRow[];
  stocks: OrdersStock[];
  unmapped: OrdersUnmapped[];
  meta: OrdersMeta;
  warnings: string[];
}

export interface WarehouseSale {
  month: string;
  mp_code: MpCode;
  warehouse_id: string;
  warehouse_name: string;
  qty: number;
  total: number;
}

export interface WarehouseStock {
  mp_code: MpCode;
  warehouse_id: string;
  warehouse_name: string;
  stock_mp: number;
}

export interface WarehouseFee {
  month: string;
  warehouse_name: string;
  storage_fee: number;
}

export interface ArticleWarehousesReport {
  article: string;
  date_from: string;
  date_to: string;
  as_of: string;
  generated_at: string;
  months: string[];
  sales: WarehouseSale[];
  stocks: WarehouseStock[];
  storage_fees: WarehouseFee[];
}

export interface MatrixParams {
  date_from?: string;
  date_to?: string;
}

export async function getMatrix(params?: MatrixParams): Promise<OrdersMatrixReport> {
  const { data } = await api.get<OrdersMatrixReport>("/orders/matrix", { params });
  return data;
}

export async function getArticleWarehouses(
  article: string,
  params?: MatrixParams,
): Promise<ArticleWarehousesReport> {
  const { data } = await api.get<ArticleWarehousesReport>("/orders/warehouses", {
    params: { article, ...params },
  });
  return data;
}
